/**
 * menu.ts '설정' 섹션(관리자 계정 등록·화이트 IP)을 화면에 보여줄 사람을 좁힌다.
 *
 * admin 등급 전체가 아니라 이 아이디 하나만 본다 - admin 등급은 xadmin(레거시)
 * 외에도 dmm(레거시), yunuy·songhw(xadmin_account) 등 여러 명이 있지만,
 * '설정'만은 화면(HomePage·Layout)과 서버 권한(requireRole('admin'),
 * app.ts) 양쪽 다 이 아이디로 좁힌다.
 *
 * 한때(관리자 계정 등록 화면이 섹션을 하나씩 부여하는 방식으로 바뀌면서)
 * '설정'도 sec:settings 토큰으로 계정마다 개별로 켤 수 있었다. 하지만 그
 * 토큰만 있으면 최고 관리자가 아닌 계정도 다른 관리자 계정을 만들거나 화이트
 * IP 를 건드릴 수 있어서(2026-09-03, yunwy 계정에서 실제로 발견) 완전히
 * 없앴다 - 서버 라우터(admins.routes.ts, whitelist.routes.ts, app.ts)도
 * requireRole('admin') 단독으로 되돌렸다. sec:settings 는 이제 어디서도
 * 새로 못 켜고, 이미 저장된 계정의 값은 그 계정을 한 번 수정·저장하면
 * AdminAccountsPage.tsx 의 authtypesToFormState 가 걸러낸다.
 */
export const SETTINGS_SECTION_TITLE = '설정';
export const SETTINGS_VISIBLE_USERID = 'xadmin';
/** menu.ts MENU 의 '설정' 섹션 key 와 같은 값 (섹션 key 는 menu.ts 참고). */
export const SETTINGS_SECTION_KEY = 'settings';

/**
 * '설정' 섹션 중 관리자 계정 화면(/admin-accounts)은 xadmin 뿐 아니라 최고
 * 관리자 권한('admin')을 가진 계정이면 누구나 보기·등록·수정할 수 있다
 * (2026-10-14). 서버(app.ts 의 /api/admins)는 원래부터 requireRole('admin')
 * 이라 화면만 넓히면 된다. 화이트 IP 관리는 그대로 xadmin 한 명만 본다.
 */
export const ADMIN_ACCOUNTS_PATH = '/admin-accounts';

/** '설정' 섹션 안의 화면 하나(to)를 이 계정이 볼 수 있는지. roles 는 parseRoles 결과. */
export function canSeeSettingsItem(roles: string[], userid: string | undefined, to: string | undefined): boolean {
  if (!roles.includes('admin')) return false;
  if (userid === SETTINGS_VISIBLE_USERID) return true;
  return to === ADMIN_ACCOUNTS_PATH;
}
